import React, { useContext, Fragment } from 'react';
import Skeleton from '../../../../../../components/OtherElements/CustomSkeleton';
import BriefInfo from '../../../../../../components/User/BriefInfo';
import { store } from './Customer';

function CustomerInfo() {
  const { state } = useContext(store);
  const { customer } = state;

  return (
    <Fragment>
      {customer ? (
        <BriefInfo user={customer} />
      ) : (
        <Skeleton count={3} height={38} />
      )}
    </Fragment>
  );
}

export default CustomerInfo;
